<template>
    <v-card tile flat height="100%" color="#171C21" class="main-visual-requirement">
        <div class="white--text w-100">
            <tit-wrap class="tit-wrap--sm">
                <tit class="font-size-lg-32 line-height-14">
                    간단하게 확인하는 <br />
                    세이지움 개봉 청약자격!
                </tit>
            </tit-wrap>

            <v-row class="row--xxs">
                <template v-for="(item, index) in items">
                    <v-col cols="12" :key="item">
                        <v-card tile flat color="rgba(255,255,255,0.05)" class="pa-12px pa-md-16px">
                            <txt class="txt--lg white--text">
                                <v-row class="row--xxs">
                                    <v-col cols="auto">
                                        <span class="font-weight-bold">0{{ index + 1 }}.</span>
                                    </v-col>
                                    <v-col>
                                        <span class="grey--text text--lighten-1">
                                            <div v-html="item" />
                                        </span>
                                    </v-col>
                                </v-row>
                            </txt>
                        </v-card>
                    </v-col>
                </template>
            </v-row>

            <tit class="tit--sm pt-30px pt-md-48px line-height-14">
                일반공급 소득 · 재산 · 지역 조건 없이 <br />
                지원 가능
            </tit>
        </div>
    </v-card>
</template>

<script>
import titWrap from "@/components/publish/styles/typography/tit-wrap.vue";
import Tit from "@/components/publish/styles/typography/tit.vue";
import Txt from "@/components/publish/styles/typography/txt.vue";

export default {
    components: {
        titWrap,
        Tit,
        Txt,
    },
    data: () => ({
        items: [
            "19세 ~ 39세 이하",
            "미혼이라면 [청년형]",
            "결혼 7년 이내 또는 혼인신고예정이라면 [신혼부부형]",
            "주택 미소유, 차량 미소유 또는 2025년 기준 <br class='d-none d-sm-block' />자동차가액 3,803만 원 이내 소유",
            //
        ],
    }),
};
</script>

<style lang="scss" scoped>
.main-visual-requirement {
    display: flex;
    align-items: center;
    padding: 30px 12px;
    background-image: url(/images/main/main-visual-requirement.jpg);
    background-size: 100%;
    background-position: center;
    box-sizing: border-box;
}
@media (min-width: 1200px) {
    .main-visual-requirement {
        display: flex;
        align-items: center;
        padding: 0 48px;
        min-width: 546px;
        max-width: 546px;
        background-position-y: bottom;
    }
}
</style>